import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';
import { HeaderState } from './reducer';

export const headerStateSelector = (state: RootState): HeaderState => state.headerState;

export const selectIsHeaderSet = createSelector([headerStateSelector], headerState => headerState.isHeaderSet);
